/** Default periodic heartbeat interval when the tab is visible and not idle-suspended. */
export const HEARTBEAT_INTERVAL_MS = 15_000;

/** Random jitter (+/-) applied to each scheduled interval. */
export const HEARTBEAT_JITTER_MS = 2_000;

/** Payload `meta.version` for collect batches. */
export const TRACKING_PAYLOAD_SCHEMA_VERSION = 1;
